module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-label",
    class: ['a-label--' + _vm.labelState, {
      'a-label--compact': _vm.isCompact
    }]
  }, [_c('div', {
    staticClass: "a-label__tag"
  }, [_c('p', {
    staticClass: "a-label__tag-title"
  }, [_vm._v(_vm._s(_vm.labelTitle))])]), _vm._v(" "), _c('p', {
    staticClass: "a-label__text"
  }, [_vm._v(_vm._s(_vm.hasText))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-430bdb40","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/checkout/components/atoms/LabelTag.vue
// module id = 527
// module chunks = 2